import styled from "styled-components";

import { Palette } from "../../vars";

const OverlayHeading = styled.h4`
  display: block;
  padding: 20px 24px 20px 15px;
  border-bottom: 1px solid ${Palette.Rebrand.Colours.G2};

  .style--rebrand & {
    margin: 0;
    color: ${Palette.Rebrand.Colours.P6};
  }
`;

export default OverlayHeading;
